var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMtalogoBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0214 21.7238L27.2681 21.494V35.7879L23.1647 36.4987L23.1547 21.1406L19.6676 20.8382V15.2091L30.0214 16.9791V21.7238ZM37.8357 33.9796L35.4006 34.3929L35.1165 32.3097L32.7446 32.611L32.4475 34.9034L29.3107 35.4462L32.4164 17.4219L35.3644 17.9225L37.8357 33.9796ZM34.6829 28.7882L34.0304 23.2847H33.8879L33.2274 28.8717L34.6829 28.7882ZM21.1171 50.7424C35.1556 50.7424 46.5322 39.5489 46.5322 25.7429C46.5332 11.934 35.1566 0.742432 21.1181 0.742432C12.3161 0.742432 4.56208 5.14348 0 11.8319L7.04337 13.0463L8.98163 27.5562C8.98866 27.5326 9.12216 27.5473 9.12216 27.5473L11.2481 13.7679L18.2965 14.9744V37.341L13.8478 38.1028V28.4917C13.8478 28.4917 14.0125 24.3518 13.9151 23.644C13.9151 23.644 13.7214 23.6489 13.7184 23.6332L11.0644 38.5907L6.64488 39.3535L3.39672 23.2415L3.20099 23.2278C3.13173 23.8109 3.43888 28.8668 3.43888 28.8668V39.9042L0.533999 40.4039C5.1543 46.6673 12.6514 50.7424 21.1171 50.7424Z",
    fill: "#0039A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtalogoBl);
export default __webpack_public_path__ + "static/media/mtalogo_bl.42990f159fd828de40568e6b4e00eb25.svg";
export { ForwardRef as ReactComponent };